﻿function notificationMarkAsRead(element) {
    if ($(element).hasClass("glow") == false) {
        //alert("no class");
        return;
    }
    $.ajax({
        type: "POST",
        url: "/api/account/UserNotificationMarkAsRead",
        async: false,
        cache: false,
        type: 'POST',
        data: {
            "": $(element).attr("data-notificationid")
        },
        dataType: "json",
        success: function (result) {
            $(element).removeClass("glow");
            $('.unreadusernotifications').each(function () {
                $(this).html(parseInt($(this).html()) - 1);
            });
            showToast("Notifikationen er nu læst");
        },
        error: function (jqXHR, exception) {
            showToast("Notifikationen kunne ikke markeres som læst");
        }
    });
}

function notificationDelete(element) {
    element = $(element).parent().parent().parent().parent().parent().parent();

    $.ajax({
        type: "POST",
        url: "/api/account/UserNotificationDelete",
        async: false,
        cache: false,
        type: 'POST',
        data: {
            "": $(element).attr("data-notificationid")
        },
        dataType: "json",
        success: function (result) {
            $(element).fadeOut(300, function () {
                $(this).remove();
                showToast("Notifikationen er nu fjernet");
            });
        },
        error: function (jqXHR, exception) {
            showToast("Notifikationen kunne ikke markeres fjernes");
        }
    });
}

function toggleusernotificationsettings(subId, type) {
    var endpoint = "/api/account/UserNotificationToggleSubscriptionEmail";
    if (type == 2) {
        endpoint = "/api/account/UserNotificationToggleSubscriptionSms";
    }
    if (type == 3) {
        endpoint = "/api/account/UserNotificationToggleSubscriptionOnlyOnErrors";
    }

    $.ajax({
        type: "POST",
        url: endpoint,
        async: false,
        cache: false,
        type: 'POST',
        data: {
            "": subId
        },
        dataType: "json",
        success: function (result) {
            showToast("Indstillinger opdateret");
        },
        error: function (jqXHR, exception) {
            showToast("Indstillingerne kunne ikke opdateres");
        }
    });
}

function toggleusernotification(type, linkedId, element, removeRow) {
    $.ajax({
        type: "POST",
        url: "/api/account/UserNotificationToggleSubscription",
        async: false,
        cache: false,
        type: 'POST',
        data: {
            "Type": type,
            "LinkedId": linkedId
        },
        dataType: "json",
        success: function (result) {
            if ($(element).hasClass("fa-bell")) {
                $(element).removeClass("fa-bell").addClass("fa-bell-slash");
                showToast("Notifikation abonnement oprettet");
            } else {
                $(element).removeClass("fa-bell-slash").addClass("fa-bell")
                if (removeRow) {
                    $(element).parent().parent().remove();
                }
                showToast("Notifikation abonnement opsagt");
            }
        },
        error: function (jqXHR, exception) {
            alert(exception);
        }
    });
}

function showToast(message, headerText = 'Notifikation', timeText = 'Just now...') {
    var t = '<div id="" class="toast" role="alert" aria-live="assertive" aria-atomic="true" data-delay="50000" style="position: fixed; top: 0; right: 0;">'+
    '<div class="toast-header">'+
    '<i class=" fas fa-bell"></i>'+
        '<strong class="mr-auto">' + headerText + '</strong> '+
    '<small>' + timeText + '</small > '+
        '<button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close" > '+
        '<span aria-hidden="true" >&times;</span> '+
        '</button> '+
    '</div> '+
        '<div class="toast-body"> ' +
        message +
    '</div> '+
'</div> ';

    $("body").append(t);
    $(".toast").toast('show');
    //$(t).toast('show');
}

function updateusernotificationtimer() {
    $.get("/api/account/UserNotificationUnreadCount", function (data, status) {
        var cnt = data;

        if ($.usernotificationUnreadCount > 0 && cnt > $.usernotificationUnreadCount) {
            getLatestUnreadNotification();
        }

        $.usernotificationUnreadCount = cnt;

        var badge = `<span id="" class="unreadusernotifications badge badge-secondary badge-light-danger badge-circle fw-bold fs-7" style="
    position: absolute;
    bottom: 0;
    left: auto;
    right: 0;
    
">`+ cnt + `</span>`;

        //$(".usernotificationmenu").html(`<span class="badge badge-secondary unreadusernotifications">` + cnt + `</span>`);
        $(".usernotificationmenu").html(`<span class="badge badge-secondary badge-light-danger badge-circle fw-bold fs-7 unreadusernotifications">` + cnt + `</span>`);

        if (cnt === 0) {
            badge = '';
        }
        $(".usernotificationbadge").each(function () {
            $(this).html(badge);
        });
        setTimeout(updateusernotificationtimer, 30000);
    });
}

function getLatestUnreadNotification() {
    $.get("/api/account/UserNotificationLatestUnread", function (data, status) {
        if (data != null) {
            var d = new Date(data.createdOn);
            var str = d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
            showToast(data.message, data.subject, str);

            $("#newnotificationspleasereload").show('slow');
        }
    });
}

$(function () {
    $.usernotificationUnreadCount = -1;
    updateusernotificationtimer();
});
